
const readmoreTriggers = [...document.querySelectorAll('.js-product-specs-more')];

readmoreTriggers.map(readmoreTrigger => {
    readmoreTrigger.addEventListener('click', () => {
        const specs = [...readmoreTrigger.closest('.js-spec-list').querySelectorAll('.js-more-spec')];
        specs.map(spec => {
           spec.classList.toggle('d-none');
        });
    });
});
